export enum ReconditioningOptions {
	NO_SELECTION = "NO_SELECTION",
	NOT_RECONDITIONED = "NOT_RECONDITIONED",
	RECONDITIONED = "RECONDITIONED",
}
